export enum NovapostPayerTypeEnum {
    SENDER = 'Sender',
    RECIPIENT = 'Recipient',
    THIRD_PERSON = 'ThirdPerson'
}
